// extracted by mini-css-extract-plugin
module.exports = {"Picture":"WebpImage_Picture__2eM4d"};